import { useState } from "react";
import GanttChart from "./GanttChart";
import styled from "styled-components";
import CommonButton from "../../../../components/common/CommonButton";
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import { getSimulatorAnalytics, getSimulatorPDF } from "../api/simulator";
import { useEffect } from "react";
import ChartResultsModal from "../simulatorManagement/ResultsChartModal";

const MainSimulatorAnalytics = ({
    selectedSimulator,
    selectedRun
}) => {
    const [selectFilter, setSelectFilter] = useState("");
    const [selectedSimulatorAnalytics, setSelectedSimulatorAnalytics] = useState(null)
    const [selectedSimulatorData, setSelectedSimulatorData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isLoadingPDF, setIsLoadingPDF] = useState(false)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenGraphic = () => {
        setOpenModal(true);
    }
    const handleChangeSelect = (e) => {
        setSelectFilter(e.target.value);
    }
    const handleApplyFilters = () => {
        setSelectedSimulatorData(selectedSimulatorData);
    }

    useEffect(() => {
        console.info("selectedRun", selectedRun)
        if (selectedRun) {
            getDataSimulatorAnalytics()
        }
    }, [selectedRun]);

    const getDataSimulatorAnalytics = async () => {
        setLoading(true)
        try {
            const data = await getSimulatorAnalytics(selectedSimulator?._id, selectedRun.run_code);
            setSelectedSimulatorAnalytics(data[0])
        } catch (error) {
            setSelectedSimulatorAnalytics(false)
        } finally {
            setLoading(false)
        }
    }

    const getDataSimulatorPDF = async () => {
        setIsLoadingPDF(true)
        try {
            const data = await getSimulatorPDF(selectedSimulator?._id, selectedRun.run_code);

            // Crear un blob URL para el PDF
            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            
            // Crear un enlace temporal para descargar el archivo
            const link = document.createElement('a');
            link.href = url;
            link.download = `simulador_${selectedSimulator?.name || 'reporte'}_${new Date().toISOString().split('T')[0]}.pdf`;
            document.body.appendChild(link);
            link.click();
            
            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            console.info('PDF descargado exitosamente')
        } catch (error) {
            console.log('Error al descargar el PDF:', error)
        } finally {
            setIsLoadingPDF(false)
        }
    }

    function parseDate(input) {
        const date = new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();

        const hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    if (loading) {
        return (
            <div>
                <h2>Cargando analíticas del simulador...</h2>
            </div>
        )
    }

    if (!selectedSimulatorAnalytics) {
        return (
            <div>
                <h2>No se encontraron analíticas del simulador</h2>
            </div>
        )
    }

    return (
        <Main>
            <ChartResultsModal
                isOpen={openModal}
                onClose={() => setOpenModal(false)}
                attributes={selectedSimulatorAnalytics?.simulator_prom_attributes}
            />
            <Header>
                <span>
                    <CommonButton
                        label="Ver gráfico de este simulador"
                        variant="outlined"
                        disabled={selectedSimulatorAnalytics?.simulator_prom_attributes?.length === 0}
                        Icon={() => (
                            <div>
                                <FontAwesomeIcon
                                    icon="fa-light fa-chart-radar"
                                    size="24px"
                                />
                            </div>
                        )}
                        onClick={handleOpenGraphic}
                    />
                    <CommonButton
                        label={isLoadingPDF ? "Generando PDF..." : "Generar PDF"}
                        variant="filled"
                        disabled={isLoadingPDF}
                        onClick={getDataSimulatorPDF}
                    />
                </span>
                <section>
                    <Select value={selectFilter} onChange={handleChangeSelect}>
                        <option value="">Todos los usuarios</option>
                        <option value="Todos los grupos" selected>Todos los grupos</option>
                        <option value="Grupo A">Grupo A</option>
                        <option value="Grupo B">Grupo B</option>
                        <option value="Grupo C">Grupo C</option>
                        <option value="Grupo D">Grupo D</option>
                    </Select>
                    <CommonButton
                        label="Filtrar"
                        variant="filled"
                        Icon={() => (
                            <div>
                                <FontAwesomeIcon
                                    icon="fa-light fa-bars-filter"
                                    size="24px"
                                />
                            </div>
                        )}
                        onClick={handleApplyFilters}
                    />
                </section>
            </Header>
            <GanttChart
                selectedSimulator={selectedSimulatorAnalytics}
                selectedSimulatorData={selectedSimulatorData}
                setSelectedSimulatorData={setSelectedSimulatorData}
            />
            <Footer>
                {
                    !!selectedSimulatorData &&
                    <>
                        <section>
                            <span>
                                <label>
                                    USUARIO
                                </label>
                                <p>
                                    {selectedSimulatorData?.user_name}
                                </p>
                            </span>
                            <span>
                                <label>
                                    PUNTAJE OBTENIDO
                                </label>
                                <p>
                                    {selectedSimulatorData?.score}
                                </p>
                            </span>
                            <span>
                                <label>
                                    FECHA DE REALIZACIÓN
                                </label>
                                <p>
                                    {parseDate(selectedSimulatorData?.timestamp)}
                                </p>
                            </span>
                        </section>
                        <section>
                            <CommonButton
                                label="Ver gráfico de este intento"
                                variant="outlined"
                                onClick={() => { }}
                            />
                            <CommonButton
                                variant="filled"
                                Icon={() => (
                                    <div>
                                        <FontAwesomeIcon
                                            icon="fa-light fa-chart-radar"
                                            size="24px"
                                        />
                                    </div>
                                )}
                                onClick={handleOpenGraphic}
                            />
                        </section>
                    </>
                }
            </Footer>
        </Main>
    )
}

export default MainSimulatorAnalytics;

const Main = styled.main`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 2rem;
`

const Header = styled.header`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

    span {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    section {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`

const Select = styled.select`
    appearance: none; /* Elimina el estilo nativo */
    height: 48px;
    width: 200px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #a8a8a8;
    cursor: pointer;

    option {
        padding: 8px 0;
        cursor: pointer;
    }
`;

const Footer = styled.footer`
    width: calc(100% - 2rem);
    height: 76px;
    background-color: #f1f1f1;
    border-radius: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;

    section {
        display: flex;
        align-items: center;
        gap: 2rem;

        span {
            width: 150px;
            display: flex;
            flex-direction: column;
            gap: .5rem;

            label {
                font-size: 12px;
                font-weight: 400;
                color: #616161;
            }

            p {
                font-size: 15px;
                font-weight: 700;
                color: #1D1D1B;
            }
        }
    }
`